module.exports = __webpack_public_path__ + "static/media/converge.5bb71803.png";